<template xmlns:v-side-nav="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
  <header class="z-depth-1">
    <v-nav nav-class="z-depth-0 grey lighten-5">
      <div class="nav-wrapper container">
        <router-link to="/" class="brand-logo left">Hoge<span class="orange-text darken-4">.class</span></router-link>
        <ul class="right hide-on-med-and-down nav-link-list">
          <li><router-link to="/" exact>{{ $t('menu.top')}}</router-link></li>
          <li><router-link to="/overview">{{ $t('menu.overview')}}</router-link></li>
          <li><router-link to="/members">{{ $t('menu.members')}}</router-link></li>
          <li><router-link to="/contact">{{ $t('menu.contact')}}</router-link></li>
          <!--<li>
            <div class="switch">
              <label>
                日本語
                <input type="checkbox" v-model="language" v-on:change="handle" class="">
                <span class="lever"></span>
                English
                </label>
            </div>
          </li>-->
        </ul>
      </div>
      <v-container>
        <div class="nav-wrapper center-align hide-on-large-only sub-menu">
          <ul class="nav-link-list">
            <li class="sub-menu-item"><router-link to="/" exact>{{ $t('menu.top')}}</router-link></li>
            <li class="sub-menu-item"><router-link to="/overview">{{ $t('menu.overview')}}</router-link></li>
            <li class="sub-menu-item"><router-link to="/members">{{ $t('menu.members')}}</router-link></li>
            <li class="sub-menu-item"><router-link to="/contact">{{ $t('menu.contact')}}</router-link></li>
          </ul>
          <!--<div class="switch">
            <label>
              日
              <input type="checkbox" v-model="language" v-on:change="handle" class="">
              <span class="lever"></span>
              Eng
            </label>
          </div>-->
        </div>
      </v-container>
    </v-nav>
  </header>
</template>

<script>
export default {
  name: 'navbar'
}
</script>


// WEBPACK FOOTER //
// Navbar.vue?4e30375e